<template>
  <div class="editor">
    <upload ref="upload" v-if="!mini" type="select" file-type="article" :auto-orient="true" :multiple="true" :max-number="10" @on-start="onStart" @on-success="onSuccess" @on-progress="onProgress" :show-list="false" @on-change="onChange" :show-input-after-success="true" style="display:none"></upload>
    <upload ref="mp3-upload" v-if="!mini" type="select" @on-start="onMp3Start" @on-success="onMp3Success" @on-progress="onMp3Progress" :show-list="false" @on-change="onMp3Change" accept="audio/mp3" :support-format="['mp3']" :show-input-after-success="true" style="display:none"></upload>
    <div class="editor-toolbar" v-ui-sticky="sticky">
      <div id="editor-toolbar"></div>
      <div class="w-e-toolbar">
        <div class="w-e-menu" @click="upload" v-if="!mini">
          <ui-icon name="icon-camera"></ui-icon>
        </div>
        <div class="w-e-menu" @click="uploadMp3" v-if="!mini">
          <ui-icon name="icon-customerservice"></ui-icon>
        </div>
      </div>
    </div>
    <div id="editor" :class="editorClasses" @drop.prevent="onDrop" @dragover.prevent="onDragover" @dragleave.prevent="onDragleave"></div>
  </div>
</template>
<script>
import Upload from "./Upload.vue";
import E from "../wangeditor/js/index.js";
import "../wangeditor/less/index.less";
import "../assets/scss/editor.scss";
import convertOssUrl from "../utils/convertOssUrl.js";
import addEventForChild from "../utils/addEventForChild.js";

import imageMethods from "../mixin/imageMethods.js";
import mp3Methods from "../mixin/mp3Methods.js";
import getFileExt from "../utils/getFileExt.js";

import renderPlayer from "../utils/renderPlayer.js";
export default {
  data() {
    return {
      editor: null,
      uploader: null,
      instances: {},
      bindImageClickEvent: false,
      player: {},
      dragOver: false,
      changed: false,
      sticky: null
    };
  },
  mixins: [imageMethods, mp3Methods],
  computed: {
    editorClasses() {
      return [{
        [`editor-drag-over`]: this.dragOver
      }];
    }
  },
  props: {
    mini: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Upload
  },
  methods: {
    addCustomButtons() {},
    upload(e) {
      this.$refs["upload"].click();
    },
    uploadMp3(e) {
      this.$refs["mp3-upload"].click();
    },

    onChange({ e }) {},
    onDrop(e) {
      this.dragOver = false;
      this.$refs["upload"].onDrop(e);
    },
    onDragover(e) {
      this.dragOver = true;
    },
    onDragleave(e) {
      this.dragOver = false;
    },
    bindEvents() {
      const parent = document.querySelector(".editor");
      document.addEventListener("click", this.renderImgPopover);
    },
    renderImgPopover(e) {
      if (e.target.classList.contains("image-holder")) {
        let img = e.target;
        this.$UiPopover({
          trigger: img,
          key: img.dataset.imgId,
          menuType: "horizon",
          closeOnClick: true,
          params: {
            id: img.getAttribute("id")
          },
          menu: [
            { icon: "delete", action: this.deleteImg },
            { icon: "redo", action: this.rotateImg },
            { icon: "icon-arrawsalt", action: this.enlargeImg },
            { icon: "icon-shrink", action: this.shrinkImg }
            // { icon: "align-left", action: this.alignImgLeft },
            // { icon: "align-center", action: this.alignImgCenter },
            // { icon: "align-right", action: this.alignImgRight }
            // {icon:'icon-font-size',action:this.addImgCaption}
          ]
        });
      }
    },
    errorHandler(msg) {
      this.$UiToast.error(this.$t(msg));
    },
    parseHtml(html) {
      let div = document.createElement("div");
      div.innerHTML = html;
      let el = div.querySelector(".editor-mp3-holder");
      if (el) {
        el.innerHTML = "";
        el.removeAttribute("data-progress");
        el.classList.remove("aplayer");
      }
      return div.innerHTML;
    },
    getHtml() {
      return new Promise((resolve, reject) => {
        if (
          !this.mini && (this.$refs["upload"].isUploading() ||
                    this.$refs["mp3-upload"].isUploading())
        ) {
          this.$UiToast.warning(this.$t("uploadingFile"));
          reject();
        } else {
          let text = this.editor.txt.text();
          if (!text) {
            this.$UiToast.warning(this.$t("mustWriteSth"));
            reject();
          } else {
            let html = this.parseHtml(this.editor.txt.html());
            resolve(html);
          }
        }
      });
    },
    setHtml(html, fileHash) {
      this.editor.txt.html(html);
      this.$nextTick(() => {
        renderPlayer(this.$el.querySelectorAll(".editor-mp3-holder"), fileHash);
      });
    }
  },
  beforeDestory() {
    document.removeEventListener("click", this.renderImgPopover);
  },
  mounted() {
    this.editor = new E("#editor-toolbar", "#editor", this.$UiToast.error);
    this.editor.customConfig.menus = [
      "head",
      "bold",
      "italic",
      "underline",
      "foreColor",
      "backColor",
      "justify",
      "link",
      "code",
      "quote",
      "emoticon",
      "embed"
    ];
    this.editor.customConfig.zIndex = 90;
    this.editor.customConfig.onchange = html => {
      this.changed = true;
      this.$emit('change', html)
    };
    this.editor.create();
    this.bindEvents();
    this.editor.errorHandler = this.errorHandler;
    if (!this.mini) {
      this.sticky = { top: 57 }
    }
  }
};

</script>
